import React from 'react'
import { Box } from '@material-ui/core'
import PropTypes from 'prop-types'
import Icon from '../../../../atoms/Icon'
import { ICON_NAMES } from '../../../../../constants'

const VisibilityCell = ({ cell }) => {
  const { value } = cell
  const label = value ? 'Visible' : 'Hidden'

  return (
    <Box style={{ marginLeft: 0 }}>
      <Box ml='-18px' display='flex' gridGap='8px' alignItems='center'>
        <Icon name={value ? ICON_NAMES.visibility : ICON_NAMES.lock} size='18px' />
        {label}
      </Box>
    </Box>
  )
}

VisibilityCell.propTypes = {
  cell: PropTypes.object
}
export default VisibilityCell
